export default __webpack_public_path__ + "static/media/screen7.fc97530b.png";